import Image from "next/image";
import {Box, HStack, Stack, Text} from "@chakra-ui/react";
import TickImage from "public/shared/check-box.png";
import {TEXT_VARIANTS} from "@/theme/components/text";

export type SimpleListProps = {
  points: string[];
};

const SimpleList = ({points}: SimpleListProps) => {
  return (
    <Box>
      <Stack spacing={2}>
        {points.map((point, index) => (
          <HStack key={index} align={"start"}>
            <Image
              alt="Point"
              src={TickImage}
              width={20}
              height={20}
              style={{paddingTop: "4px"}}
            />{" "}
            <Text
              variant={TEXT_VARIANTS.BODY2}
              style={{lineHeight: "24px"}}
              color="text.100"
              _groupHover={{color: "white"}}
            >
              {point}
            </Text>
          </HStack>
        ))}
      </Stack>
    </Box>
  );
};

export default SimpleList;
